import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from '../TopNavBar';
import SideNavBar from '../SideNavBar';

const DashboardAdmin = () => {
    return (
        <div className="dashboard-container">
            <TopNavBar />
            <SideNavBar />
            <div className="main-content">
                <Outlet />
            </div>
        </div>
    );
};

export default DashboardAdmin;
